import { makeStyles } from "@material-ui/core/styles";

export const useTemporaryNdcStyles = makeStyles((theme) => ({
  dialogContent: {
    padding: "24px 32px",
  },

  dialogTitleWithClose: {
    position: "relative",
    paddingRight: theme.spacing(6),
  },

  dialogCloseButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: "50%",
    transform: "translateY(-50%)",
  },

  sectionTitle: {
    marginTop: 28,
    marginBottom: 12,
    fontWeight: 600,
    color: "#2a2a2a",
    fontSize: 18,
  },

  footerActions: {
    padding: "20px 24px",
    display: "flex",
    justifyContent: "flex-end",
    gap: 12,
    marginLeft: "auto",
  },

  tableWrapper: {
    marginTop: 16,
  },

  modalTitleSpacing: {
    marginBottom: 12,
  },
}));
